import { CONFIG } from '../core/config';
import { ViewModel } from './view-model';
import { NodeInput } from './node-input';
import { NodeOutput } from './node-output';
import { Node } from './node';

export class InternalNodeInputMapping implements ViewModel {
  readonly friendlyTypeNameSingular: string = 'Internal Node Input Mapping';
  readonly apiRoute: string = CONFIG.apiRoutes.internalNodeInputMapping;

  nodes: Node[] = new Array<Node>();
  inputs: NodeInput[] = new Array<NodeInput>();
  outputs: NodeOutput[] = new Array<NodeOutput>();

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.inputs = new Array<NodeInput>();
    if (data.inputs) {
      for (const rawInput of data.inputs) {
        const input = new NodeInput();
        input.loadFromJson(rawInput);
        this.inputs.push(input);
      }
    }

    this.outputs = new Array<NodeOutput>();
    if (data.outputs) {
      for (const rawOutput of data.outputs) {
        const output = new NodeOutput();
        output.loadFromJson(rawOutput);
        this.outputs.push(output);
      }
    }

    this.nodes = new Array<Node>();
    if (data.nodes) {
      for (const rawNode of data.nodes) {
        const node = new Node();
        node.loadFromJson(rawNode);
        this.nodes.push(node);
      }
    }
  }
}
